<template>

  <div>
    <label class="uk-form-label" v-html="label"></label>
    <div class="uk-input uk-select uk-box-shadow-medium uk-text-ellipsis">{{ displayValue }}</div>
    <div uk-dropdown="mode:click;animation:uk-animation-slide-top-medium" class="uk-box-shadow-large uk-width-1-1 delphi-dropdown" style="max-height: 300px; overflow-y: auto;">
      <div class="uk-text-small uk-link uk-text-right" @click="clear($event)">{{ l('Clear') }}</div>

      <div v-for="option in options">
        <label class="delphi-checkbox">
          <input type="checkbox" :value="option" @change="handleChange($event, option)" :checked="isChecked(option)" ref="checkbox">
          <span v-html="option[optionLabelKey]"/>
        </label>

        <div class="uk-margin-left" v-if="maxLevels > 1 && option[optionChildrenKey] && option[optionChildrenKey].length">
          <label class="delphi-checkbox" v-for="subOption in option[optionChildrenKey]">
            <input type="checkbox" :value="subOption" @change="handleChange($event, subOption, option)" :checked="isChecked(subOption)">
            <span v-html="subOption[optionLabelKey]"/>
          </label>
        </div>

      </div>
    </div>
  </div>

</template>

<script setup>
import {onMounted, ref} from 'vue'

const emit = defineEmits(['update:modelValue', 'change'])

const props = defineProps({
  currentLevel: {type: Number, default: 1},
  startLevel: {type: Number, default: 1},
  maxLevels: {type: Number, default: 1},
  optionLabelKey: {type: String, required: true},
  optionChildrenKey: {type: String, required: true},
  modelValue: {
    type: Set
  },
  name: {
    type: String,
  },
  label: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  options: {
    type: Array,
    required: true
  }
})

const l = window.l

let selected = ref(new Set())
let displayValue = ref('')

let setAllChildren = (parent, state) => {
  if (!parent || props.maxLevels === 1) return

  parent[props.optionChildrenKey].forEach(child => {
    if (state) {
      selected.value.add(child)
    } else {
      selected.value.delete(child)
    }
  })
}

let handleChange = ($event, item, parent) => {

  if (item || parent) {

    let checked = $event.target.checked

    if (checked) {
      selected.value.add(item)
    } else {
      selected.value.delete(item)
    }

    //on uncheck, uncheck all children
    if (!parent) {
      setAllChildren(item, selected.value.has(item))
    } else {

      if (selected.value.has(item)) {

        if (props.maxLevels > 1 && props.currentLevel > 1) {

        } else {
          //if child, check if all siblings are checked too and check the parent instead
          let isAllChildrenSelected = true;

          parent[props.optionChildrenKey].forEach(child => {
            isAllChildrenSelected = isAllChildrenSelected && selected.value.has(child)
          })

          if (isAllChildrenSelected) {
            selected.value.add(parent)
          }
        }

      } else {
        selected.value.delete(parent)
      }
    }
  }

  if (!(item || parent)) {
    selected.value.clear()
  }

  updateDisplayValue()
  emit('update:modelValue', selected.value)
  emit('change', selected.value)
}

let updateDisplayValue = () => {
  if (!selected.value || !selected.value.size) {
    displayValue.value = l('All')
    return
  }

  if (selected.value.size > 3) {
    displayValue.value = `${selected.value.size} ${l('ItemsSelected')}`
    return
  }

  displayValue.value = [...selected.value].map(v => v[props.optionLabelKey]).join(', ')
}

onMounted(() => {
  initState()
})


let initState = () => {
  selected.value = props.modelValue || []

  props.options.forEach(option => {
    if (selected.value.has(option)) {
      setAllChildren(option, true)
    }
  })

  updateDisplayValue()
}

let clear = ($event) => {
  if (!selected.value.size) return
  handleChange($event)
}

let isChecked = (option) => selected.value.has(option)

</script>


